import { useState } from "react";
import { motion } from "framer-motion";
import { GALLERY } from "../data/site";

const CATS = ["All", "Concrete", "Kitchens", "Bathrooms", "Decks"];

export const Gallery = () => {
  const [active, setActive] = useState("All");
  const items = active === "All" ? GALLERY : GALLERY.filter((g) => g.cat === active);

  return (
    <section id="work" className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--apex-accent)]">Recent work</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[var(--apex-primary)] mt-3">
            Projects across the Valley
          </h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button
              key={c}
              data-testid={`gallery-filter-${c.toLowerCase()}`}
              onClick={() => setActive(c)}
              className={`rounded-sm px-4 py-2 text-sm font-medium border transition-colors ${
                active === c
                  ? "bg-[var(--apex-primary)] text-white border-[var(--apex-primary)]"
                  : "bg-white text-slate-600 border-slate-300 hover:border-slate-400"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((g, i) => (
          <motion.figure
            key={g.src}
            layout
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
            className="group relative overflow-hidden rounded-md ring-1 ring-slate-200"
          >
            <img
              src={g.src}
              alt={g.alt}
              className="w-full h-56 lg:h-72 object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-slate-900/80 to-transparent p-4">
              <span className="text-white text-sm font-semibold">{g.cat}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
